// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2UNbq","col":"Table_col__iT0dh","fulfillmentStatus":"Table_fulfillmentStatus__2vvY8","emailCol":"Table_emailCol__IcG3e"};